<template>
  <v-row
    align="center"
    justify="center"
    no-gutters
    class="background"
  >
    <v-card
      width="100%"
      max-width="1000px"
      max-height="90%"
      class="pa-0"
      flat
    >
      <v-card-title>Считайте QR-код на точке</v-card-title>
      <VueQrReader
        @code-scanned="codeScanned"
        @error-captured="errorCaptured"
        stop-on-scanned
        draw-on-found
        line-color="#00FF00"
        :line-width="5"
        use-back-camera
        responsive
      >
      </VueQrReader>
    </v-card>
  </v-row>
</template>

<script>
import HandledError from '@/utils/handledError'
import VueQrReader from '@/components/VueQrReader'

export default {
  methods: {
    codeScanned (scanned) {
      this.axios
        .post('/qr/check/' + scanned)
        .then((response) => {
          this.$router.push('/audit')
        })
        .catch((err) => {
          if (err instanceof HandledError) return
          // Ошибка в js
          this.$router.push(`/error?message=${err.message}&from=${this.$router.currentRoute.path}`)
        })
    },

    errorCaptured (error) {
      let errorMessage = ''
      switch (error.name) {
        case 'NotAllowedError':
          errorMessage = 'Доступ к камере запрещён'
          break
        case 'NotFoundError':
          errorMessage = 'Камера не найдена'
          break
        case 'NotSupportedError':
          errorMessage = 'Возможно используется небезопасный протокол (http)'
          break
        case 'NotReadableError':
          errorMessage = 'Нет доступа к камере'
          break
        case 'OverconstrainedError':
          errorMessage = 'Ограничения не соответствуют ни одной установленной камере'
          break
        default:
          errorMessage = 'UNKNOWN ERROR: ' + error.message
      }

      this.$router.push(`/error?error=${errorMessage}&from=${this.$router.currentRoute.path}`)
    }
  },

  components: {
    VueQrReader
  }
}
</script>
